
export enum EndPoint {
    SUBMIT_FNOL = '/v1/old-web/fnol'
}
